<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />


  <div class="page" style="height: 100%; position:relative">
    <div class="formgrid grid form-file">
          <div class="field col-12">
            <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
            <div class="button-wrapper">
              <span :class="['label', {'active': fileToUpload.length > 0}]">
                {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Seleziona File' }}
              </span>
              <input id="upload" type="file" ref="file" :key="keyInputReset" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
            </div>
            <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
            <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
          </div>
          <!-- <div class="field col-12 md:col-3 flex align-items-end pb-1">
            <Button label="Carica" iconPos="right" @click="uploadFile" icon="pi pi-upload" class="w-full" />
          </div> -->
        </div>
        <div>
          <DataTable :value="items" >
              <Column field="riga" header="Riga"></Column>
              <Column field="msg" header="Errore"></Column>
              <Column field="value" header="Stringa"></Column>
          </DataTable>
        </div>
  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          :disabled="fileToUpload.length == 0"
          label="Esegui Check" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>

import { ref, getCurrentInstance} from 'vue';
import Service from '@/services/ask-operation/operation-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
    
  },
  components: {
    Loader
  },
    
  setup() {
    const page = { name: 'check-sdd-xml'}
    const loader = ref(false)
    const toast = useToast();
    const items = ref([])
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const fileToUpload = ref([])
    const allowedType = {
      'xml' : 'text/xml'
    }
    const keyInputReset = ref(0)
    const validationErrors = ref({})
    const submitted = ref(false)
      

    const handleFileUpload = (evt) => {
      fileToUpload.value = []
      evt.preventDefault()
      submitted.value = false;
      fileToUpload.value = self.refs.file.files
    }
      
    const onOkButton = () => {
      submitted.value = true;
      toast.removeGroup(page.name);
      if (validateForm() ) {
         
        loader.value = true
        service.checkSddXml(fileToUpload.value)
        .then((res) => {
          items.value = res.items
          console.log(items.value);
        })
        .catch(() => {
          fileToUpload.value = []
          loader.value = false
          toast.add({severity:'error', summary: 'Attenzione', detail:'Errore invio file', group: page.name});
        })
        .finally(()=>{
          keyInputReset.value = new Date()
          fileToUpload.value = []
          loader.value = false
          self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })            

      }
    }
    

    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }


    const validateForm = () => {

    if (fileToUpload.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(file => [Object.values(allowedType).join(', ')].includes(file.type), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }


    return {
      page,
      fileToUpload,
      items,
      allowedType,
      loader,
      handleFileUpload,
      keyInputReset,
      validationErrors, 
      submitted,
      onCancelButton,
      onOkButton
    }
  }
}


</script>

<style scoped>
.p-dropdown-items .p-dropdown-item{
  text-transform: uppercase !important;
}
.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
</style>

